module.exports = __webpack_public_path__ + "img/k.15d2a6a7.jpg";